import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79aa403a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "outer" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "新規申請", -1))
const _hoisted_5 = { class: "request" }
const _hoisted_6 = { class: "flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "タイトル", -1))
const _hoisted_8 = { class: "flex-margin title" }
const _hoisted_9 = { class: "flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "事業所", -1))
const _hoisted_11 = { class: "flex-margin" }
const _hoisted_12 = { class: "flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "所属部署", -1))
const _hoisted_14 = { class: "flex-margin" }
const _hoisted_15 = { class: "flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "添付ファイル", -1))
const _hoisted_17 = { class: "flex-margin" }
const _hoisted_18 = { class: "workflow" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow-outer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "arrow-round" })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "処理種別"),
    /*#__PURE__*/_createElementVNode("th", null, "対象者")
  ])
], -1))
const _hoisted_22 = { class: "flow-type" }
const _hoisted_23 = { class: "flow-member" }
const _hoisted_24 = {
  key: 0,
  class: "delete_btn"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex btn" }
const _hoisted_27 = { class: "addflow" }
const _hoisted_28 = { class: "post" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextBox = _resolveComponent("TextBox")!
  const _component_PullDown = _resolveComponent("PullDown")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_CommonCombo = _resolveComponent("CommonCombo")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_TextBox, {
                InitValue: _ctx.title,
                Placeholder: 'ファイル名が自動入力されます',
                readonly: 'readonly',
                ErrorMessage: _ctx.titleError,
                onChangeText: _ctx.SetTitle
              }, null, 8, ["InitValue", "ErrorMessage", "onChangeText"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_PullDown, {
                options: _ctx.officeOptions,
                modelValue: _ctx.office,
                defaultOption: true,
                ErrorMessage: _ctx.officeError,
                disabled: false,
                onValue: _ctx.SetOffice
              }, null, 8, ["options", "modelValue", "ErrorMessage", "onValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_PullDown, {
                options: _ctx.departmentOptions,
                modelValue: _ctx.department,
                defaultOption: true,
                ErrorMessage: _ctx.departmentError,
                disabled: false,
                onValue: _ctx.SetDepartment
              }, null, 8, ["options", "modelValue", "ErrorMessage", "onValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_FileUpload, {
                ErrorMessage: _ctx.fileError,
                onUploadFile: _ctx.setFileData
              }, null, 8, ["ErrorMessage", "onUploadFile"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("table", null, [
                _hoisted_21,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flows, (flow, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.getProcessName(flow.ProcessingType)), 1),
                      _createElementVNode("td", _hoisted_23, [
                        _createVNode(_component_CommonCombo, {
                          InitValue: flow.TargetUserCodeList,
                          HasError: flow.HasError,
                          Disabled: flow.Disabled,
                          onChangeFlowTarget: ($event: any) => (_ctx.changeFlowTarget($event, index))
                        }, null, 8, ["InitValue", "HasError", "Disabled", "onChangeFlowTarget"]),
                        (!flow.Disabled && index != 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("span", {
                                class: "round_btn",
                                onClick: _withModifiers(($event: any) => (_ctx.deleteFlow(index)), ["stop"])
                              }, null, 8, _hoisted_25)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_CommonButton, {
                label: `フロー追加`,
                onButtonClick: _ctx.addFlow
              }, null, 8, ["onButtonClick"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_CommonButton, {
                label: `申請`,
                onButtonClick: _ctx.post
              }, null, 8, ["onButtonClick"])
            ])
          ])
        ])
      ])
    ])
  ]))
}